module.exports = __webpack_public_path__ + "static/media/discount-code-percent.fa18abe6.svg";